import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from './constants';
import { getCompanyTools, getCompanyToolVersions, getToolVersionsStats, getToolVersionStatsEpds } from './toolsApi';
import { ToolVersionStatsType } from 'types/tools/stats/ToolVersionStatsType';

export const useCompanyTools = (companyId: string | undefined) =>
  useQuery({
    queryKey: [QUERY_KEYS.COMPANY_TOOLS, companyId],
    queryFn: ({ signal }) => getCompanyTools(companyId!, { signal }),
    throwOnError: true,
    enabled: !!companyId,
  });

export const useCompanyToolVersions = (companyId: string | undefined) =>
  useQuery({
    queryKey: [QUERY_KEYS.COMPANY_TOOL_VERSIONS, companyId],
    queryFn: ({ signal }) => getCompanyToolVersions(companyId!, { signal }),
    throwOnError: true,
    enabled: !!companyId,
  });

export const useToolVersionsStats = (toolId: string) =>
  useQuery({
    queryKey: [QUERY_KEYS.TOOL_STATS, toolId],
    queryFn: ({ signal }) => getToolVersionsStats(toolId, { signal }),
    throwOnError: true,
  });

export const useToolVersionStatsEpds = (toolId: string, versionOrd: number, type: ToolVersionStatsType) =>
  useQuery({
    queryKey: [QUERY_KEYS.TOOL_STATS, toolId, versionOrd, type],
    queryFn: ({ signal }) => getToolVersionStatsEpds(toolId, versionOrd, type, { signal }),
  });
